'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.slicedReducer = exports.createReducerAspect = undefined;

var _reducerAspect = require('./reducerAspect');

var _reducerAspect2 = _interopRequireDefault(_reducerAspect);

var _slicedReducer = require('./slicedReducer');

var _slicedReducer2 = _interopRequireDefault(_slicedReducer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} //*** 
//*** Promote all feature-redux utilities through a centralized module.
//*** 
// NOTE: This non-default export supports ES6 imports.
//       Example:
//         import { createFeature }    from 'feature-redux';
//       -or-
//         import * as FeatureU from 'feature-redux';


exports.createReducerAspect = _reducerAspect2.default;
exports.slicedReducer = _slicedReducer2.default; // NOTE: This default export supports CommonJS modules (otherwise Babel does NOT promote them).
//       Example:
//         const { createFeature } = require('feature-redux');
//       -or-
//         const FeatureU   = require('feature-redux');

exports.default = {
  createReducerAspect: _reducerAspect2.default,
  slicedReducer: _slicedReducer2.default
};